import React from 'react';
import ReactDOM from 'react-dom';
import Calculator from '../components/cms/Calculator';

document.querySelectorAll('[data-cms-calculator]').forEach(element => {
  ReactDOM.render(<Calculator {...JSON.parse(element.dataset.cmsCalculator)}/>, element);
});
if (document.querySelector('[data-cms-chart]')) {
  import('../components/cms/Chart').then(({ default: Chart }) => {
    document.querySelectorAll('[data-cms-chart]').forEach(element => ReactDOM.render(<Chart data={JSON.parse(element.dataset.cmsChart)}/>, element));
  });
}
